import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ChartOptions } from 'chart.js';

@Component({
  selector: 'app-info-pie',
  templateUrl: './info-pie.component.html',
  styleUrls: ['./info-pie.component.css'],
})
export class InfoPieComponent implements OnInit {
  @Input() lable!: string;
  @Input() percentage?: number;

  pieChartOptions = {
    responsive: true, 
    maintainAspectRatio: false,
    aspectRatio: 2, 
    plugins: {
      datalabels: {
        color: '#FFFFFF',
        font: { weight: 'bold', size: 15 },
        textAlign: 'center',
        formatter: function (value: any) {
          return value + '%';
        },
      },
    },
  };
  pieChartDatasets: any;

  constructor() {}

  ngOnInit() {
    this.pieChartDatasets = [
      {
        data: [this.percentage??0, 100 - (this.percentage??0)],
        backgroundColor: ['#0D7167', '#6EAAA4'],
      },
    ];
  }

  updateChartData(percentage){
    if (!percentage) {
      return;
    }
    this.pieChartDatasets[0].data[0]=percentage;
    this.pieChartDatasets[0].data[1]=100-percentage;
    this.pieChartDatasets[0].data._chartjs.listeners[0].chart.update();
    
  }
}
